import React, {useState, useEffect} from 'react';
import './DropdownInput.module.sass';
import api from "../../../../utils/api";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownToggle from "../../DropdownToggle/DropdownToggle";
import DropdownMenu from "../../DropdownMenu/DropdownMenu";

const dropdownInput = (props) => {

  const [options, optionsHandler] = useState([]);

  useEffect(() => {
    if (props.optionsUrl) {
        api.get(props.optionsUrl).then((result) => {
          optionsHandler(result.data.map(el => (props.formatter(el))));
        });
    }
  }, [props.optionsUrl]);

  const valueHandler = (key) => {
    if (props.hasOwnProperty('onSelect')) {
      props.onSelect(key);
    }
  };

  const opts = props.optionsUrl ? options : props.options;

  const match = opts.find(el => {
    return(
      el.value === props.value
    )

  });

  return (

    <Dropdown className={props.className}>
      <Dropdown.Toggle {...props}
                       value={opts.length > 0 && props.value != null && props.value.length > 0
                         ? (
                           match ? match.text
                             : props.value
                         )
                         : ''}
                       as={DropdownToggle}/>

      <Dropdown.Menu role="menu" as={DropdownMenu}>
        {
          opts.map((el, index) => {
            return <Dropdown.Item onSelect={(key) => valueHandler(key)} key={index}
                                  eventKey={el.value}>{el.text ? el.text : el.value}</Dropdown.Item>
          })
        }
      </Dropdown.Menu>
    </Dropdown>


  );
};

export default dropdownInput;
